import React from "react";
import { FieldArray, FormikProps } from "formik";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { handleValidNumber2 } from "src/utils/formUtils/ValidNumber";
import { OfflineOrderFormValues } from "src/models/OfflineOrder.model";

type Props = {
  formikProps: FormikProps<OfflineOrderFormValues>;
  onlineMode?: any[];
};

const PaymentModel = ({ formikProps, onlineMode }: Props) => {
  const { values, setFieldValue, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        {/* <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button> */}
      </div>
      <div className="flex flex-col gap-4">
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300">
            <thead className="bg-gray-100 text-left">
              <tr>
                <th className="border px-4 py-2">Note Value</th>
                <th className="border px-4 py-2">Quantity</th>
                <th className="border px-4 py-2">Total Amount</th>
              </tr>
            </thead>
            <tbody>
              <FieldArray name="paymentMode">
                {() =>
                  values?.paymentMode.filter((item)=>item.type==="PHYSICAL").map((note, index) => {
                    const quantityValue = note.quantity || "";

                    return (
                      <tr key={index}>
                        <td className="border px-4 py-2">{note.name} X</td>
                        <td className="border px-4 py-2">
                          <ATMTextField
                            name={`paymentMode[${index}].quantity`}
                            value={values.paymentMode[index].quantity}
                            onChange={(e) =>
                              handleValidNumber2(e) &&
                              setFieldValue(
                                `paymentMode[${index}].quantity`,
                                e.target.value
                              )
                            }
                            placeholder="Enter quantity"
                            onBlur={handleBlur}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          {note.value * Number(quantityValue || 0)}
                        </td>
                      </tr>
                    );
                  })
                }
              </FieldArray>
            </tbody>
          </table>
        </div>
        <div className="border rounded-md p-1">
          <table className="w-full border text-left">
            <thead>
              <tr className="bg-gray-100 text-sm">
                <th className="p-2">Payment In</th>
                <th className="p-2">Amount</th>
              </tr>
            </thead>
            <tbody>
              {onlineMode?.map((mode, i) => {
                const item = values.paymentMode.find(
                  (item) => item.name === mode.label
                ) || { value: 0 }; // Changed to use value

                return (
                  <tr key={i} className="border-t">
                    <td className="p-2">{mode.label}</td>
                    <td className="p-2">
                      <ATMTextField
                        name={`paymentMode_${mode.value}`}
                        value={item.value.toString()} // Using value instead of quantity
                        onChange={(e) => {
                          const amount = e.target.value;
                          if (
                            handleValidNumber2({
                              target: { value: amount },
                            } as React.ChangeEvent<HTMLInputElement>)
                          ) {
                            const newInflow = values.paymentMode.filter(
                              (item) => item.name !== mode.label
                            );

                            if (amount) {
                              newInflow.push({
                                name: mode.label,
                                value: Number(amount),
                                quantity: 1,
                                type: mode.type,
                              });
                            }

                            setFieldValue("paymentMode", newInflow);
                          }
                        }}
                        onBlur={handleBlur}
                        label=""
                        placeholder="Amount"
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      
    </div>
  );
};

export default PaymentModel;
